import { render } from "./avatar_with_skills.vue?vue&type=template&id=734ea5b8"
import script from "./avatar_with_skills.vue?vue&type=script&lang=js"
export * from "./avatar_with_skills.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./avatar_with_skills.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__